import { Text } from '@pixi/react'
import { FeatureToggleType, FixedContainer, formatToCommaWithLang, t, toCommaOptions, useFeatureToggleStore, usePlayerStore } from '@slot-nx/core'
import { TextStyle, Container as PixiContainer } from 'pixi.js'
import { useRef, useEffect } from 'react'
import { winBarService } from '../domain/winning/service/winbarService'

interface BalanceProps {
  x: number
  y: number
  width: number
  height: number
  currency: string
  currencyStyle?: TextStyle
  titleStyle?: TextStyle
  amountStyle?: TextStyle
}

export const Balance = (props: BalanceProps) => {
  const defaultCurrencyStyle = useRef(
    new TextStyle({
      fontSize: 20,
      fill: '#9299A0',
      align: 'center',
    }),
  )
  const defaultTitleStyle = useRef(
    new TextStyle({
      fontSize: 30,
      fill: '#9299A0',
      align: 'center',
    }),
  )
  const defaultAmountStyle = useRef(
    new TextStyle({
      fontSize: 38,
      fill: '#FFFFFF',
      align: 'center',
    }),
  )

  const currencyStyle = props.currencyStyle ? props.currencyStyle : defaultCurrencyStyle.current
  const titleStyle = props.titleStyle ? props.titleStyle : defaultTitleStyle.current
  const amountStyle = props.amountStyle ? props.amountStyle : defaultAmountStyle.current

  const balanceRef = useRef<PixiContainer>()
  const balance = usePlayerStore(x => x.balance)

  useEffect(() => {
    winBarService.balanceBar = balanceRef.current as PixiContainer
  }, [])

  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const isDisableCurrencyDisplay = !featureToggle.get(FeatureToggleType.disableCurrencyDisplay)

  return (
    <FixedContainer
      name="currency"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      ref={(el: PixiContainer | null) => {
        balanceRef.current = el as PixiContainer
      }}
    >
      {isDisableCurrencyDisplay && (
        <Text
          name="currency"
          x={30}
          anchor={0.5}
          y={82}
          text={props.currency}
          style={currencyStyle}
        />
      )}
      <Text name="title" x={160} y={30} anchor={0.5} text={t('main_control_panel_balance')} style={titleStyle} />

      <Text
        name="amount"
        x={65}
        anchor={[0, 0.5]}
        y={82}
        text={formatToCommaWithLang(balance, navigator.language, toCommaOptions.forceTwoDecimalPlaces)}
        style={amountStyle}
      />
    </FixedContainer>
  )
}
export { FixedContainer }
